import { render, staticRenderFns } from "./AuditTrail.vue?vue&type=template&id=704543f8&scoped=true&"
import script from "./AuditTrail.vue?vue&type=script&lang=js&"
export * from "./AuditTrail.vue?vue&type=script&lang=js&"
import style0 from "./AuditTrail.vue?vue&type=style&index=0&id=704543f8&lang=scss&scoped=true&"
import style1 from "./AuditTrail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704543f8",
  null
  
)

export default component.exports